module.exports = __webpack_public_path__ + "media/lesson/fonts/Frutiger/FrutigerBold-b909629eb28b8cda9da7c9d6d0f04065.eot";